"use strict";

// Document ready
document.addEventListener("DOMContentLoaded", function () {
  // cookie statement
  var ktCookieStatementContainer = document.querySelector("#ktCookieStatementContainer");

  if (ktCookieStatementContainer && ktCookieStatementContainer.length !== null) {
    if (!checkCookieRecord("kt-cookie-statement-key")) {
      document.querySelector("#ktCookieStatement").style.display = "block";
    } // Conset to allow cookies


    var cookiesConsentButton = document.querySelector("#ktCookieStatementConfirm");

    if (cookiesConsentButton && cookiesConsentButton.length !== null) {
      cookiesConsentButton.addEventListener("click", function () {
        setCookieRecord("kt-cookie-statement-key", 1, 10);
        document.querySelector("#ktCookieStatement").style.display = "none";
      });
    }
  }
}); // Nastaví cookie hodnotu dle klíče po zadanou dobu (pro celou cestu /)

function setCookieRecord(cookieName, cookieValue, expirationDaysCount) {
  var date = new Date();
  date.setFullYear(date.getFullYear() + expirationDaysCount);
  document.cookie = cookieName + "=" + cookieValue + "; path=/; expires=" + date.toUTCString();
} // Smaže cookie hodnotu dle klíče po zadanou dobu (pro celou cestu /)


function removeCookieRecord(cookieName) {
  var date = new Date();
  date.setFullYear(date.getFullYear() - 1);
  document.cookie = cookieName + '=""; path=/; expires=' + date.toUTCString();
} // Vrátí hodnotu cookie dle klíče


function getCookieRecord(cookieName) {
  var name = cookieName + "=";
  var cookies = document.cookie.split(";");

  for (var i = 0; i < cookies.length; i++) {
    var cookieValue = cookies[i];

    while (cookieValue.charAt(0) == " ") {
      cookieValue = cookieValue.substring(1);
    }

    if (cookieValue.indexOf(name) == 0) {
      return cookieValue.substring(name.length, cookieValue.length);
    }
  }

  return "";
} // Zkontroluje, zda existuje cookie (hodnota dle klíče)


function checkCookieRecord(cookieName) {
  var cookieValue = getCookieRecord(cookieName);

  if (cookieValue != "") {
    return true;
  }

  return false;
} // Odstraní z URL parametr a jeho hodnotu


function removeUrlParameter(parameter) {
  var url = document.location.href;
  var urlParts = url.split("?");

  if (urlParts.length >= 2) {
    var urlBase = urlParts.shift();
    var queryString = urlParts.join("?");
    var prefix = encodeURIComponent(parameter) + "=";
    var parts = queryString.split(/[&;]/g);

    for (var i = parts.length; i-- > 0;) {
      if (parts[i].lastIndexOf(prefix, 0) !== -1) {
        parts.splice(i, 1);
      }
    }

    url = urlBase + "?" + parts.join("&");
    window.history.pushState("", document.title, url);
  }

  return url;
} // Vrátí hodnotu parametru z URL podle jeho klíče (názvu)
// BUJS #1 – getParameterByName by James Padolsey (http://james.padolsey.com/javascript/bujs-1-getparameterbyname/)


function getUrlParameterValue(key) {
  var match = RegExp("[?&]" + key + "=([^&]*)").exec(window.location.search);
  return match && decodeURIComponent(match[1].replace("/+/g", " "));
} // Vrátí hodnotu parametru z URL podle jeho klíče (názvu)
// add or update query string parameter by Niyaz (http://stackoverflow.com/a/6021027)


function addOrUpdateUrlParameterValue(key, value) {
  var url = window.location.href;
  var regExp = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  var separator = url.indexOf("?") !== -1 ? "&" : "?";

  if (url.match(regExp)) {
    window.history.pushState({}, null, url.replace(regExp, "$1" + key + "=" + value + "$2"));
  } else {
    window.history.pushState({}, null, url + separator + key + "=" + value);
  }
} // Document ready


document.addEventListener("DOMContentLoaded", function () {
  tablesStyleCorrection();
  videoIframeWrap();
}); //Tables style correction

function tablesStyleCorrection() {
  removeWidthHeight(".entry-content table");
  removeWidthHeight(".entry-content tr");
  removeWidthHeight(".entry-content th");
  removeWidthHeight(".entry-content td");
} //Remove width and height inline style


function removeWidthHeight(selector) {
  var correctedElement = document.querySelectorAll(selector),
      i;

  for (i = 0; i < correctedElement.length; ++i) {
    if (correctedElement[i].style.removeProperty) {
      correctedElement[i].style.removeProperty("width");
    } else {
      correctedElement[i].style.removeAttribute("width");
    }

    if (correctedElement[i].style.removeProperty) {
      correctedElement[i].style.removeProperty("height");
    } else {
      correctedElement[i].style.removeAttribute("height");
    }
  }
} //Video iframe wrap


function videoIframeWrap() {
  var contentIframes = document.querySelectorAll(".entry-content iframe"),
      i;

  for (i = 0; i < contentIframes.length; ++i) {
    var itemSrc = contentIframes[i].getAttribute("src");

    if (itemSrc.indexOf("youtube") != -1) {
      contentIframes[i].removeAttribute("height");
      contentIframes[i].removeAttribute("width");
      var iframeWrap = document.createElement("div");
      iframeWrap.classList.add("ratio", "ratio-16x9");
      contentIframes[i].parentNode.insertBefore(iframeWrap, contentIframes[i]);
      iframeWrap.appendChild(contentIframes[i]);
    }
  }
}

document.querySelectorAll('input[type="file"]').forEach(function (input) {
  input.addEventListener('change', function (e) {
    this.nextElementSibling.textContent = this.value.match(/([^\/\\]+)$/)[1];
  });
}); // Document ready

document.addEventListener("DOMContentLoaded", function () {
  LazyLoadingInit();
}); // Lazy loading Init

function LazyLoadingInit() {
  var myLazyLoad = new LazyLoad({
    elements_selector: "[data-src], [data-bg]",
    threshold: 400
  });
}

var slideUp = function slideUp(target) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  target.style.transitionProperty = 'height, margin, padding';
  target.style.transitionDuration = duration + 'ms';
  target.style.boxSizing = 'border-box';
  target.style.height = target.offsetHeight + 'px';
  target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  window.setTimeout(function () {
    target.style.display = 'none';
    target.style.removeProperty('height');
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property'); //alert("!");
  }, duration);
};

var slideDown = function slideDown(target) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  target.style.removeProperty('display');
  var display = window.getComputedStyle(target).display;
  if (display === 'none') display = 'block';
  target.style.display = display;
  var height = target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  target.offsetHeight;
  target.style.boxSizing = 'border-box';
  target.style.transitionProperty = "height, margin, padding";
  target.style.transitionDuration = duration + 'ms';
  target.style.height = height + 'px';
  target.style.removeProperty('padding-top');
  target.style.removeProperty('padding-bottom');
  target.style.removeProperty('margin-top');
  target.style.removeProperty('margin-bottom');
  window.setTimeout(function () {
    target.style.removeProperty('height');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
  }, duration);
};

var slideToggle = function slideToggle(target) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;

  if (window.getComputedStyle(target).display === 'none') {
    return slideDown(target, duration);
  } else {
    return slideUp(target, duration);
  }
};

var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  return new bootstrap.Tooltip(tooltipTriggerEl);
});

var brilo = function () {
  return {
    // Px to Rem conversion
    pxToRem: function pxToRem(value) {
      var rootFontSize = 16;
      value = value / rootFontSize;
      value = value.toFixed(3);
      return value;
    }
  };
}(); // Document ready


document.addEventListener("DOMContentLoaded", function () {
  scrollTriggers();
}); // Funkce pro animované posunutí na prvek v DOM dokumentu

function moveToHtmlTarget(elemnt, topOffset, bottomOffset) {
  var offset = elemnt.offsetTop;

  if (topOffset > 0) {
    offset = offset - topOffset;
  }

  if (bottomOffset > 0) {
    offset = offset + bottomOffset;
  }

  window.scrollTo({
    behavior: 'smooth',
    left: 0,
    top: offset
  });
  return this;
}

function scrollTriggers() {
  var scrollTrigger = document.querySelectorAll(".scroll-trigger");
  var i; // Button--------------

  for (i = 0; i < scrollTrigger.length; i++) {
    scrollTrigger[i].addEventListener("click", function () {
      var sectionId = this.getAttribute("data-id-section");
      var topOfSection = document.querySelector("#" + sectionId);
      var topOfSectionPx = topOfSection.offsetTop;
      var isIE = '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style;

      if (isIE) {
        window.scrollTo(0, topOfSectionPx);
      } else {
        topOfSection.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }
    });
  }
} // // Document ready
// document.addEventListener("DOMContentLoaded", function () {
//   submitFormOnFakeButton();
//   preventDefaultUtil();
//   moveToHtmlTargetInit();
// });
// //Submit form with fake button
// function submitFormOnFakeButton() {
//   $("#submitButton, .submitButton").click(function () {
//     if ($(this).hasClass("disabled")) {
//       return false;
//     }
//     $(this)
//       .parents("form")
//       .submit();
//   });
// }
// //Prevent Default
// function preventDefaultUtil() {
//   var preventDefaultItems = document.querySelectorAll(".js-prevent-default"),
//     i;
//   if (preventDefaultItems[0] != undefined) {
//     for (i = 0; i < preventDefaultItems.length; ++i) {
//       preventDefaultItems[i].addEventListener("click", function (e) {
//         e.preventDefault();
//       });
//     }
//   }
// }
// function moveToHtmlTargetInit() {
//   $("[data-kt-target]").click(function () {
//     var targetElement = $($(this).data("kt-target"));
//     var targetBottomOffset = $(this).data("kt-bottom-offset");
//     var targetTopOffset = $(this).data("kt-top-offset");
//     moveToHtmlTarget(targetElement, targetTopOffset, targetBottomOffset);
//   });
// }

/* Trick with viewport height when need 100vh at mobile. */


var vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', "".concat(vh, "px"));
window.addEventListener('resize', function () {
  var vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', "".concat(vh, "px"));
});
document.addEventListener("DOMContentLoaded", function () {
  if (typeof document.getElementById("company-name") != 'undefined' && document.getElementById("company-name") != null) {
    document.getElementById("contact-hidden").style.display = 'none';
    var inputs = document.querySelectorAll(".js-contact-opening-hidden");
    var executed = false;

    for (var i = 0; i < inputs.length; i++) {
      inputs[i].addEventListener('input', function () {
        if (!executed && this.value.length != 0) {
          executed = true;
          slideDown(document.getElementById("contact-hidden"));
        }
      });
    }
  }
});
document.addEventListener("DOMContentLoaded", function () {
  var headerMain = document.querySelector('.js-header-main');
  var headroom = new Headroom(headerMain, {
    offset: 80
  });
  headroom.init();
  var formSearchOpener = document.querySelector('.js-form-search__opener');

  if (typeof formSearchOpener != 'undefined' && formSearchOpener != null) {
    formSearchOpener.onclick = function () {
      formSearchOpener.parentNode.classList.toggle('is-open');
    };

    var formSearchElement = document.getElementById('header-search');
    document.addEventListener('click', function (event) {
      var isClickInside = formSearchElement.contains(event.target);

      if (!isClickInside) {
        formSearchOpener.parentNode.classList.remove('is-open');
      }
    });
  }

  var langOpener = document.querySelector('.js-header-main__lang-opener');

  if (typeof langOpener != 'undefined' && langOpener != null) {
    langOpener.onclick = function () {
      langOpener.parentNode.classList.toggle('is-open');
    };

    var langElement = document.getElementById('header-lang');
    document.addEventListener('click', function (event) {
      var isClickInside = langElement.contains(event.target);

      if (!isClickInside) {
        langOpener.parentNode.classList.remove('is-open');
      }
    });
  }

  var body = document.body;
  var headerOpener = document.querySelector('.js-header-main__opener');

  if (typeof headerOpener != 'undefined' && headerOpener != null) {
    headerOpener.onclick = function () {
      body.classList.toggle('is-nav-open');
    };
  }

  var subMenuOpener = document.querySelectorAll('.js-sub-menu__opener');

  if (typeof subMenuOpener != 'undefined' && subMenuOpener != null) {
    for (var i = 0; i < subMenuOpener.length; i++) {
      subMenuOpener[i].onclick = function () {
        this.parentNode.classList.toggle('is-open');
      };
    }
  }
});
document.addEventListener("DOMContentLoaded", function () {
  if (typeof document.querySelector("js-newsletter-section__input") != 'undefined' && document.querySelector("js-newsletter-section__input") != null) {
    document.querySelector("js-newsletter-section__input").addEventListener('input', function () {
      if (this.value.length == 0) {
        this.classList.remove('is-val');
      } else {
        this.classList.add('is-val');
      }
    });
  }
});
document.addEventListener("DOMContentLoaded", function () {
  var body = document.body;
  var infoOpener = document.querySelector('.js-info-section__opener');

  if (typeof infoOpener != 'undefined' && infoOpener != null) {
    infoOpener.onclick = function () {
      body.classList.toggle('is-info-closed');
    };
  }
});
document.addEventListener("DOMContentLoaded", function () {
  var referencesList = document.querySelector('.js-references-section__list');

  if (typeof referencesList != 'undefined' && referencesList != null) {
    var referencesSlider = tns({
      container: '.js-references-section__list',
      items: 1,
      nav: true,
      navPosition: 'bottom',
      controls: false,
      gutter: 0,
      responsive: {
        1576: {
          nav: false,
          controls: true
        },
        1440: {
          items: 3,
          gutter: 56
        },
        1200: {
          items: 3,
          gutter: 32
        },
        576: {
          items: 2,
          gutter: 32
        }
      }
    });
  }
});
document.addEventListener("DOMContentLoaded", function () {
  var postsList = document.querySelector('.js-posts-section__list');

  if (typeof postsList != 'undefined' && postsList != null) {
    var postsSliderList = document.querySelectorAll(".js-posts-section__list");

    for (var i = 0; i < postsSliderList.length; i++) {
      var postsSlider = tns({
        container: postsSliderList[i],
        items: 1,
        nav: true,
        navPosition: 'bottom',
        controls: false,
        gutter: 0,
        responsive: {
          1576: {
            nav: false,
            controls: true
          },
          1440: {
            items: 3,
            gutter: 56
          },
          1200: {
            items: 3,
            gutter: 32
          },
          576: {
            items: 2,
            gutter: 32
          }
        }
      });
    }
  }
});
//# sourceMappingURL=functions.js.map
